import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=7880376c&scoped=true&"
import script from "./app-aside.vue?vue&type=script&lang=js&"
export * from "./app-aside.vue?vue&type=script&lang=js&"
import style0 from "./app-aside.vue?vue&type=style&index=0&id=7880376c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880376c",
  null
  
)

export default component.exports